import { FormGroup, fieldSubscription, useField, useIsDisabled } from '@ff-it/form';
import { formatError } from 'utilities';
import { FactorPolicyEditor } from './FactorPolicyEditor';
import { draftToPolicy, policyToDraft, type FactorApplicationPolicy } from './form';
import * as styles from './FactorPolicyEditor.css';

export function FactorPolicyField({
  name,
  side,
  disabled = false,
}: {
  name: 'client_factor_policy' | 'provider_factor_policy' | 'factor_policy';
  side: 'Client' | 'Provider';
  disabled?: boolean;
}) {
  const { input, meta } = useField<FactorApplicationPolicy | null>(name, {
    allowNull: true,
    subscription: fieldSubscription,
  });
  const locked = useIsDisabled(disabled);
  return (
    <FormGroup
      className={`mb-0 ${styles.section}`}
      meta={{
        ...meta,
        submitError: meta.submitError ? formatError({ data: meta.submitError }) : undefined,
      }}
    >
      <FactorPolicyEditor
        label={side}
        presenceLabel="Auto exclusions"
        value={policyToDraft(input.value)}
        disabled={disabled}
        readOnly={locked && !disabled}
        disabledReason={disabled ? 'Not applicable to this activity.' : undefined}
        onChange={(value) => input.onChange(draftToPolicy(value))}
        onBlur={input.onBlur}
        onFocus={input.onFocus}
      />
    </FormGroup>
  );
}
